export default {
    quarterly: 'ربع سنوي',
    "by-date": "حسب التاريخ",
    year: 'سنة',
    month: 'شهري',
    start: 'بداية',
    end: 'نهاية',
    message: {
        'creation-failed': 'فشل الإنشاء، الرجاء محاولة إنشاء واحد جديد.',
        'please-create-a-chart': 'الرجاء إنشاء مخطط.'
    },
    'divide-chart': 'المخطط',
    'quarter': 'ربع سنوي'
}